import { Modal } from "antd";
import React, { Fragment, useEffect, useReducer, useRef } from "react";
import Countdown from "react-countdown";
import FullScreenLoader from "../../components/fullScreenLoader/fullScreenLoader";
import { fnId } from "../../helper/constant/getVisualFNMix";
import { arrayValidation } from "../../helper/validation";
import { HelperContext } from "../../store/helperStore";
import TestHeader from "../testHeader/testHeader";
import MultiTap from "../tMultiTap/multiTap";
import "./faceNameMix.scss";

const reducer = (state, action) => {
  switch (action.type) {
    case "ID":
      return { ...state, id: action.payload };
    case "STEP":
      return { ...state, step: action.payload };
    case "IS_MSG":
      return { ...state, isMsg: action.payload };
    case "COUNTDOWN":
      return { ...state, isStartCountDown: action.payload };
    case "AFTER_MATH_COMPLETE": // after step 3 before start step 4
      return { ...state, mathTestCompleteInst: action.payload };
    case "INSTRUCTION": // after step 3 before start step 4
      return { ...state, instruction: action.payload };
    default:
      return state;
  }
};

export default function FaceNameMix({ question }) {
  const fnObjKey = Object.keys(question);

  const initialState = {
    id: `${fnId}1`, // for appearing images sequentially
    step: 1, // there are total 4 steps
    isMsg: true, // for starting msg
    isStartCountDown: false,
    instruction: false,
    mathTestCompleteInst: false,
  };

  const { helperC, dispatchHelper } = HelperContext();
  const autoImageSlider = useRef();
  const autoGrpImageSlider = useRef();
  const instrTimeout = useRef();

  const { faceArray, groupFaces, dummyMathQues } = question;

  console.log("groupFaces", groupFaces);

  const [FNMix, dispatchFNMix] = useReducer(reducer, initialState);

  console.log(faceArray);
  const {
    id,
    step,
    isMsg,
    isStartCountDown,
    instruction,
    mathTestCompleteInst,
  } = FNMix;

  console.log("datadata", FNMix);

  const handleFaces = (index) => {
    if (index < faceArray.length - 1) {
      dispatchFNMix({ type: "ID", payload: faceArray[index + 1].id });
    } else {
      dispatchFNMix({ type: "STEP", payload: 2 });
      dispatchFNMix({ type: "ID", payload: `${fnId}1` });
    }
  };

  const handleGrpFaces = (index) => {
    if (index < groupFaces.length - 1) {
      dispatchFNMix({
        type: "ID",
        payload: groupFaces[index + 1].id,
      });
    } else {
      // if (helperC.testType === "CALIBRATION") {
      //   dispatchHelper({ type: "RUNNING_QUES_ID", payload: 1 });
      // } else {
      dispatchFNMix({ type: "IS_MSG", payload: true });
      dispatchFNMix({ type: "STEP", payload: 3 });
      //timer for starting math test
      instrTimeout.current = setTimeout(() => {
        clearTimeout(instrTimeout.current);
        dispatchFNMix({ type: "IS_MSG", payload: false });
        dispatchFNMix({ type: "COUNTDOWN", payload: true });
      }, 15 * 1000);
      // }
    }
  };

  const handleImageSlider = (index, time) => {
    autoImageSlider.current = setTimeout(() => {
      clearTimeout(autoImageSlider.current);
      handleFaces(index);
    }, time * 1000);
  };

  const handleGrpImageSlider = (index, time) => {
    autoGrpImageSlider.current = setTimeout(() => {
      clearTimeout(autoGrpImageSlider.current);
      handleGrpFaces(index);
    }, time * 1000);
  };

  console.log(helperC.testType === "CALIBRATION");

  const idToMoveNext =
    helperC.testType === "CALIBRATION"
      ? helperC.fnQuesId
      : helperC.runningQuesId;

  console.log("idToMoveNext fnQuesId", helperC.fnQuesId);
  console.log("idToMoveNext runningQuesId", helperC.runningQuesId);
  console.log("idToMoveNext", idToMoveNext);

  const handleMathDummyTestSubmit = (getStep) => {
    dispatchFNMix({ type: "STEP", payload: getStep });
    dispatchFNMix({ type: "AFTER_MATH_COMPLETE", payload: true });
    dispatchFNMix({ type: "INSTRUCTION", payload: true });

    if (helperC.testType === "CALIBRATION") {
      dispatchHelper({ type: "FN_QUES_ID", payload: `${fnId}1` });
    } else {
      dispatchHelper({ type: "RUNNING_QUES_ID", payload: `${fnId}1` });
    }
    // dispatchFNMix({ type: "AFTER_MATH_COMPLETE", payload: false });
    // dispatchFNMix({ type: "COUNTDOWN", payload: true });
    // const timeout = setTimeout(() => {
    //   clearTimeout(timeout);
    // }, 5 * 1000);
  };

  const handleQuestion = (customQuestions) => {
    return (
      <>
        {arrayValidation(customQuestions) &&
          customQuestions.map((launchedTest, index) => {
            return (
              <Fragment key={index}>
                {idToMoveNext === launchedTest.id && (
                  <div key={index} className="test-block">
                    <Fragment>
                      <TestHeader
                        sectionName={"FACE-NAME MIX"}
                        question={launchedTest}
                        questions={customQuestions}
                        index={index}
                      />
                      <div className="test-body">
                        <MultiTap
                          question={launchedTest}
                          questions={customQuestions}
                          index={index}
                          handleDummySubmit={handleMathDummyTestSubmit}
                        />
                      </div>
                    </Fragment>
                  </div>
                )}
              </Fragment>
            );
          })}
      </>
    );
  };

  useEffect(() => {
    //preloading image
    faceArray.forEach((face) => {
      const img = new Image();
      img.src = require(`../../assets/img/faceNameMix/${face.names}.png`);
    });

    if (step === 1) {
      instrTimeout.current = setTimeout(() => {
        clearTimeout(instrTimeout.current);
        dispatchFNMix({ type: "IS_MSG", payload: false });
      }, 5 * 1000);
    }
  }, []);

  const thankYouMsg = () => {
    return (
      <div className="thank-msg">
        <h1 className="thank-list">
          <ul>
            <li>
              {`For the next ${!helperC.testType ? 5 : 2} minutes`} we would
              like to test your basic numerical skills.
            </li>
            <li>Answer as quickly as possible and do not skip any question.</li>
            <li>
              The questions are middle school level and should be easy for most
              of you.
            </li>
          </ul>
        </h1>
        <h1 className="atb">All the best.</h1>
      </div>
    );
  };

  return (
    <>
      {isMsg && step === 1 ? (
        <FullScreenLoader
          msg={`You will be shown ${faceArray.length} pictures of ladies and their names. Pay attention and see if you can remember most of them.`}
        />
      ) : (
        <>
          {(step === 1 || step === 2) && (
            <div className="test-block">
              <TestHeader sectionName={"FACE-NAME MIX"} />
              <div className="test-body">
                <div
                  data-aos="zoom-in"
                  className="test-body-content"
                  style={{ height: "100%" }}
                >
                  {step === 1 && (
                    <>
                      <p className="fn-mix-msg">Please see it carefully</p>
                      {faceArray.map((face, index) => {
                        return (
                          <Fragment key={index}>
                            {id === face.id && (
                              <div className="fn-img">
                                <img
                                  alt=""
                                  src={
                                    require(`../../assets/img/faceNameMix/${face.names}.png`)
                                  }
                                />
                                <h3 style={{ background: face.bgColor }}>
                                  {face.names}
                                </h3>
                                {handleImageSlider(index, 3)}
                              </div>
                            )}
                          </Fragment>
                        );
                      })}
                    </>
                  )}

                  {step === 2 && (
                    <>
                      <p className="fn-mix-msg">Please see it carefully</p>
                      {groupFaces.map((groupFace, index) => {
                        return (
                          <Fragment key={index}>
                            {id === groupFace.id && (
                              <div className="group-faces">
                                {handleGrpImageSlider(index, 5)}
                                {groupFace.faces.map((face, index) => (
                                  <div key={index} className="group-face">
                                    <img
                                      alt=""
                                      src={
                                        require(`../../assets/img/faceNameMix/${face.names}.png`)
                                      }
                                    />
                                    <h3>{face.names}</h3>
                                  </div>
                                ))}
                              </div>
                            )}
                          </Fragment>
                        );
                      })}
                    </>
                  )}
                </div>
              </div>
            </div>
          )}
        </>
      )}

      {isMsg && step === 3 ? (
        <FullScreenLoader
          specialMsg="Thank you for watching."
          Component={thankYouMsg}
        />
      ) : isStartCountDown && step === 3 ? (
        <div className="test-instruction-fn">
          <div className="test-instruction-blk">
            <MyCountdown
              timer={3}
              handleCountdown={() => {
                dispatchFNMix({ type: "COUNTDOWN", payload: false });
              }}
            />
          </div>
        </div>
      ) : (
        step === 3 && handleQuestion(dummyMathQues)
      )}
      {mathTestCompleteInst && step === 4 ? (
        <Modal
          style={{ top: "30%" }}
          visible={instruction}
          className="sml-modal"
          footer={
            <div className="sml-footer">
              <button
                className="custom-btn"
                onClick={() => {
                  dispatchFNMix({
                    type: "AFTER_MATH_COMPLETE",
                    payload: false,
                  });
                  dispatchFNMix({ type: "COUNTDOWN", payload: true });
                  dispatchFNMix({ type: "INSTRUCTION", payload: false });
                }}
              >
                Continue
              </button>
            </div>
          }
        >
          <h3 style={{ textAlign: "center" }}>
            Thank you for completing the numerical test. You will now complete
            the Face Name Test. Please try and recall as many faces as you can
            by selecting the correct names.
            <br />
            Best of luck !
          </h3>
        </Modal>
      ) : isStartCountDown && step === 4 ? (
        <div className="test-instruction">
          <div className="test-instruction-blk">
            <MyCountdown
              timer={10}
              handleCountdown={() => {
                dispatchFNMix({ type: "COUNTDOWN", payload: false });
                // dispatchFNMix({ type: "INSTRUCTION", payload: true });
              }}
            />
          </div>
        </div>
      ) : (
        step === 4 && handleQuestion(helperC.faceData.faceArray)
      )}
    </>
  );
}

const MyCountdown = React.memo(function MyCountdown({
  timer,
  handleCountdown,
}) {
  return (
    <Countdown
      date={Date.now() + timer * 1000}
      onComplete={() => handleCountdown()}
      renderer={({ seconds }) => {
        return <span className="timer">{seconds}</span>;
      }}
    />
  );
});
